module.exports = __webpack_public_path__ + "img/mrgreen.6c933fa7.svg";